<template>
  <div class="success-small-step-container">
    <span class="success-small-step-container__icon" />
    <p class="success-small-step-container__text">
      {{ trans('guided_search.success_small.text') }}
    </p>
    <div class="success-small-step-container__btn">
      <a class="btn btn--primary btn--with-icon" :href="$search_url">
        {{ trans('guided_search.success.browse') }}
        <span />
      </a>
    </div>
    <div class="success-small-step-container__link">
      <a class="link" :href="$home_url">
        {{ trans('guided_search.success_small.return') }}
      </a>
    </div>
  </div>
</template>

<script>
import { translationMixin } from '@tools/translation';
import { number } from '@tools/number-formatter';

export default {
  mixins: [ translationMixin ],
  data() {
    return {
      offerCount: 0,
    };
  },
  mounted() {
    this.offerCount = number(window.initialAppState.offer_count);
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'starter_end',
      step: 'starter_end',
      funnel: 'support-contact-form',
    });
  },
};
</script>
